"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var ErrorList = /** @class */ (function () {
    function ErrorList(errors) {
        this.errors = arrayExtensions_1.clone(errors);
    }
    ErrorList.prototype.getList = function () {
        return this.errors.map(function (e) { return e.errorMessage; });
    };
    ErrorList.prototype.getPropertyErrors = function () {
        return this.errors;
    };
    ErrorList.prototype.getErrors = function (key) {
        return this.errors.filter(function (e) { return e.propertyName.toLowerCase() === key.toLowerCase(); });
    };
    ErrorList.prototype.getErrorMessage = function (key) {
        return this.errors.filter(function (e) { return e.propertyName.toLowerCase() === key.toLowerCase(); }).map(function (e) { return e.errorMessage; }).join('\r\n');
    };
    ErrorList.prototype.getErrorsForPrefix = function (prefix) {
        var errors = {};
        this.errors.filter(function (e) { return e.propertyName.toLowerCase().indexOf(prefix.toLowerCase() + '.') == 0; }).forEach(function (e) {
            var propertyWithoutPrefix = e.propertyName.substr(e.propertyName.lastIndexOf('.') + 1);
            propertyWithoutPrefix = propertyWithoutPrefix.substr(0, 1).toLowerCase() + propertyWithoutPrefix.substr(1);
            if (errors.hasOwnProperty(propertyWithoutPrefix))
                errors[propertyWithoutPrefix].push(e);
            else
                errors[propertyWithoutPrefix] = [e];
        });
        return errors;
    };
    ErrorList.prototype.getErrorMessages = function (prefix) {
        var errors = {};
        this.errors.filter(function (e) { return e.propertyName.toLowerCase().indexOf(prefix.toLowerCase() + '.') == 0; }).forEach(function (e) {
            var propertyWithoutPrefix = e.propertyName.substr(e.propertyName.lastIndexOf('.') + 1);
            propertyWithoutPrefix = propertyWithoutPrefix.substr(0, 1).toLowerCase() + propertyWithoutPrefix.substr(1);
            if (errors.hasOwnProperty(propertyWithoutPrefix))
                errors[propertyWithoutPrefix] = errors[propertyWithoutPrefix] + '\r\n' + e.errorMessage;
            else
                errors[propertyWithoutPrefix] = e.errorMessage;
        });
        return errors;
    };
    ErrorList.prototype.getSubList = function (prefix) {
        return new ErrorList(this.errors
            .filter(function (e) { return e.propertyName.toLowerCase().indexOf(prefix.toLowerCase() + '.') == 0; })
            .map(function (e) { return { propertyName: e.propertyName.substring(prefix.length + 1), errorMessage: e.errorMessage, isWarning: e.isWarning }; }));
    };
    return ErrorList;
}());
exports.ErrorList = ErrorList;
